import React, { useState, useContext } from 'react'
import { Form, Row, Col } from 'react-bootstrap'

import api          from '../../services/api'
import BtnLoader    from '../buttons/loader/index.js'
import StoreContext from '../../components/storage/context'
import errorHandlerShow from '../errorHandlerShow/index.js'

/**
 * AUTO COMPLETE FIELDS
 * realiza a leitura do arquivo csv e fornecer:
 * header, tipo do dado e uma amostra de cada coluna do arquivo.
 */
const AutoCompleteFields = ({
    handleSaveFields,
    setTableHidden,
    setAlert,
    setShowAlert,
    delimiter
}) => {
    const {pk_user, setToken, token} = useContext(StoreContext);

    const [file, setFile]       = useState('')
    const [loading, setLoading] = useState(false);

    const autoSaveFields = ({data}) => {
        let dataRows = data.map((item, index) => (
            {
                id: index,
                name_field: item.column,
                datalake_field_name: item.column,
                data_type: item.dtype,
                des_field: '',
                descriptionCode: '',
                mask_field: '',
                LGPD: '',
                example: item.sample,
                status: false
            }
        ))

        handleSaveFields(dataRows)
        setTableHidden("")
    }

    // realiza leitura do arquivo csv e informa quando o arquivo não foi selecionado.
    const handleFileChosen = (event) => {
        event.preventDefault()
        setLoading(true)

        if (file) {
            if (file.size > 2097152) {
                setAlert({
                    header: 'Ops... esse arquivo é grandão heim haha', 
                    message: 'Por gentileza, adicione um arquivo csv de amostra com tamanho máximo de 2MB.',
                    type: 'danger',
                    options_btn: []
                })
    
                // show alert with mensage
                setShowAlert(true)
                setLoading(false)
            } else if (!delimiter) {
                setAlert({
                    header: 'Está faltando algo pra processar sua solicitação.', 
                    message: 'Por gentileza, preencha o campo delimitador do arquivo. Lembre-se, esse será o delimitador que será usado pra ler o arquivo de amostra',
                    type: 'danger',
                    options_btn: []
                })
    
                // show alert with mensage
                setShowAlert(true)
                setLoading(false)
            } else {

                let formData = new FormData();
                const delimiter_without_spaces = delimiter.replace( /\s/g, '')

                formData.append('file', file);

                api.post('file-sample', formData, {
                    params: {"type-inference": "sample-fields", "delimiter": delimiter_without_spaces, 'pk_user': pk_user},
                    headers: {"Content-Type": "multipart/form-data", 'Authorization': token}
                }).then(response => {
                    const data = response.data
                    autoSaveFields(data)
                    setLoading(false)
                    document.getElementById("fileSample").value = "";
                })
                .catch(error => {
                    errorHandlerShow(error, setToken, setAlert, setShowAlert)
                    setLoading(false)
                    document.getElementById("fileSample").value = "";
                })
            }
        } else {
            setAlert({
                header: 'Ops... não está esquecendo de algo?', 
                message: 'Por gentileza, adicione um arquivo csv de amostra com tamanho máximo de 2MB.',
                type: 'danger',
                options_btn: []
            })

            // show alert with mensage
            setShowAlert(true)
            setLoading(false)
        }
    };

    return (
        <Form noValidate>
            <Row className="mb-3">
                <Col md>
                    <Form.Group controlId="upload_csv" className="mb-3">
                        <Form.Label>Carregar arquivo de exemplo no formato csv (Máx. 2 MB e encoding UTF-8)</Form.Label>
                        <Form.Control
                            id="fileSample"
                            type="file"
                            accept=".csv"
                            onChange={event => setFile(event.target.files[0]) }
                        />
                    </Form.Group>
                </Col>
                <Col md>
                    <BtnLoader
                        loading={loading}
                        messageNotLoading="Processar"
                        messageLoading="Processando"
                        style={"btn-loader-145px mf-register-load-field"}
                        variant={"primary"}
                        onClick={event => handleFileChosen(event)}
                        hasOnClick={true}
                    />
                </Col>
            </Row>
        </Form>
    )
}

export default AutoCompleteFields;